import React from 'react';
export function HeroSection() {
  return <section className="relative pt-16 pb-0 md:pt-28 overflow-hidden bg-[#F4EDE4]" data-id="element-32">
      {/* Glow */}
      <div className="absolute top-[-100px] left-1/2 -translate-x-1/2 w-[700px] h-[450px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(184,149,106,0.22) 0%, transparent 70%)'
    }} data-id="element-33" />

      <div className="max-w-4xl mx-auto px-4 relative z-10 text-center" data-id="element-34">
        {/* Brand */}
        <div className="animate-fade-in-up inline-flex gap-2 px-5 py-2 rounded-full bg-white border border-[#E8D5C4] text-[#5A2A3D] text-xs font-bold tracking-[0.2em] mb-8 shadow-sm uppercase pt-[8px] pb-[8px] pl-[20px] pr-[20px] mt-[-99px] items-center justify-start" data-id="element-35">
          <span className="w-1.5 h-1.5 rounded-full bg-[#B8956A] animate-pulse" data-id="element-36" />
          Kit Lashista · Tu Agenda Profesional™
        </div>

        {/* Headline */}
        <h1 className="animate-fade-in-up delay-100 text-4xl sm:text-5xl md:text-7xl text-[#2D1A22] leading-[1.05] tracking-tight mb-6" data-id="element-37">
          La fórmula N°1 para eliminar cancelaciones
          <br data-id="element-38" />
          <span className="italic text-[#5A2A3D]" data-id="element-39">en solo 1 SEMANA</span>
        </h1>

        <p className="animate-fade-in-up delay-150 text-base md:text-lg text-[#5A4A4F] max-w-2xl mx-auto leading-relaxed mb-10" data-id="element-40">
          El sistema N°1 para lashistas argentinas — Filtro + Políticas + Agenda
          + Rescate + Blindaje + Élite.
        </p>

        {/* Product Mockup */}
        <div className="animate-fade-in-up delay-200 flex justify-center mb-10" data-id="element-41">
          <img src="https://cdn.magicpatterns.com/uploads/nvZoxomZ8zdEsDhcjawDAL/Captura_de_pantalla_2026-05-25_a_la(s)_12.59.58_p._m._-_Editado_(1).png" alt="Kit Lashista Tu Agenda Profesional — El kit más completo para lashistas" className="w-full max-w-2xl drop-shadow-2xl pt-[0px] mt-[-35px]" data-id="element-42" />
        </div>

        {/* Product Card */}
        <div className="animate-fade-in-up delay-300 bg-white border border-[#E8D5C4] rounded-2xl p-6 md:p-10 mb-8 relative overflow-hidden shadow-lg mt-[-30px]" data-id="element-43">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#B8956A] via-[#C9A97A] to-[#B8956A]" data-id="element-44" />
          <div className="text-[10px] tracking-[0.25em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-45">
            Sistema Digital 2026
          </div>
          <h2 className="text-2xl md:text-4xl text-[#2D1A22] mb-4" data-id="element-46">
            Kit Lashista <span className="italic" data-id="element-47">Tu Agenda Profesional</span>™
          </h2>
          <p className="text-base md:text-lg text-[#5A2A3D] font-medium mb-5 italic" data-id="element-48">
            Filtro + Políticas + Agenda + Rescate + Blindaje + Élite
          </p>
          <p className="text-[#5A4A4F] text-base md:text-lg leading-relaxed max-w-3xl mx-auto" data-id="element-49">
            Políticas + scripts + sistema de reservas + protección física +
            mentalidad de dueña listos para implementar. Sin perder más tiempo
            aguantando cancelaciones sin hacer nada.
          </p>
        </div>

        {/* CTA */}
        <div className="animate-fade-in-up delay-350 flex flex-col items-center mb-10" data-id="element-50">
          <a href="#pricing" className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-12 py-5 text-base md:text-lg font-bold text-white hover:bg-[#6B3D4F] rounded-full transition-all active:scale-95 shadow-xl tracking-wider uppercase bg-[#ED4A89]" data-id="element-51">
            → Quiero mi Kit ahora
          </a>
          <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mt-6 text-xs md:text-sm font-medium text-[#5A4A4F]" data-id="element-52">
            <span data-id="element-53">🛡️ Garantía 30 días</span>
            <span className="hidden sm:inline text-[#E8D5C4]" data-id="element-54">|</span>
            <span data-id="element-55">🔒 Pago seguro</span>
            <span className="hidden sm:inline text-[#E8D5C4]" data-id="element-56">|</span>
            <span data-id="element-57">💳 Mercado Pago</span>
          </div>
        </div>

        {/* Badges */}
        <div className="animate-fade-in-up delay-400 flex flex-wrap justify-center gap-2 md:gap-3 mb-16" data-id="element-58">
          {['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Para lashistas argentinas', '📚 4 Tomos + 4 Bonos + 1 Upsell', '🔒 Pago seguro'].map((b, i) => <span key={i} className="px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-[#FAF6F0] text-[#5A4A4F] text-xs md:text-sm font-medium border border-[#E8D5C4]" data-id="element-59">
              {b}
            </span>)}
        </div>
      </div>

      {/* Stats Bar */}
      <div className="animate-fade-in delay-600 border-y border-[#E8D5C4] bg-white/70 backdrop-blur-sm" data-id="element-60">
        <div className="max-w-5xl mx-auto px-4" data-id="element-61">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-6 py-8 md:py-10" data-id="element-62">
            {[{
            val: '+500',
            label: 'lashistas ya lo tienen'
          }, {
            val: '4',
            label: 'Tomos completos'
          }, {
            val: '4',
            label: 'Bonos incluidos'
          }, {
            val: '4.9/5 ★',
            label: 'calificación'
          }].map((s, i) => <div key={i} className="text-center px-4" data-id="element-63">
                <div className="text-3xl md:text-5xl text-[#2D1A22] mb-1" data-id="element-64">
                  {s.val}
                </div>
                <div className="text-[10px] md:text-xs text-[#5A4A4F] font-medium uppercase tracking-[0.18em]" data-id="element-65">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}